module.exports = __webpack_public_path__ + "static/media/empty-wallet-add.43abac88.svg";